import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonMatchValidatorDirective } from './match.directive';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
	],
	exports: [
		CommonMatchValidatorDirective,
	],
	declarations: [
		CommonMatchValidatorDirective,
	],
	entryComponents: [],
})
export class CommonMatchValidatorModule {}
